export const KYC_FAQ_DATA = [
    {
      title: "What type of documents are required?",
      description:
        "For business Know Your Customer (KYC) compliance, typically the required documents include: (1). PAN/Aadhar Card (2). GST documents(if any) (3). Business Registration Documents etc"
    },
    {
      title: "How much time will the verification process take after submitting the documents?",
      description:
        "In general, it can take around 1-3 business days to complete the KYC process at our portal",
    },
    {
      title: "How will I know if the process is completed?",
      description: "You will receive a verification on email/Whatsapp once we have successfully reviewed all of your submitted documents."
    },
  ];
  